import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ImageGalleryComponent from "../images/ImageGalleryComponent";
import { obtenerFotosTipoHab } from "../../services/motorService";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
export default function ResponsiveDialog({ open, handleClose, room }) {
  const [images, setImages] = useState([]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md")); // Detecta si es móvil o tablet

  const location = useLocation();
    const params = new URLSearchParams(location.search);
    const hotcodParam = params.get("hotcod");
    const hotCod = hotcodParam ?? Cookies.get("hotCod") ?? null;
  useEffect(() => {
    const fetchImages = async () => {
      if (room) {
        const tipoHabitacion = room.ratePlans[0].ratePlan.TarifaTipoHab;
        console.log("TIPO HABITACIÒN:", room.ratePlans[0].ratePlan);
        console.log("HOTEL EN DIALOG:", hotCod);
        console.log("TIPO HAB SOLICITDAO", tipoHabitacion);
        const fotos = await obtenerFotosTipoHab(hotCod, tipoHabitacion);
        console.log("FOTOS:", fotos);

        if (fotos && Array.isArray(fotos) && fotos.length > 0) {
          const formattedImages = fotos.map((foto) => ({
            original: `data:image/png;base64,${foto.TipoHabFoto}`,
            thumbnail: `data:image/png;base64,${foto.TipoHabFoto}`,
          }));
          setImages(formattedImages);
        } else {
          setImages([
            {
              original: room?.image
                ? `data:image/png;base64,${room.image}`
                : "https://via.placeholder.com/1000x600",
              thumbnail: room?.image
                ? `data:image/png;base64,${room.image}`
                : "https://via.placeholder.com/1000x600",
            },
          ]);
        }
      }
    };

    if (open) {
      fetchImages();
    } else {
      setImages([]); // Limpiar las imágenes cuando se cierra el diálogo
    }
  }, [room, open]);

  return (
    <Dialog
      fullScreen={fullScreen} // Ocupa toda la pantalla si es móvil o tablet
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      maxWidth="md" // Establecemos un tamaño máximo para el ancho en pantallas grandes
      fullWidth
      PaperProps={{
        style: {
          maxHeight: fullScreen ? "100%" : "80vh", // Diferente tamaño según si es móvil o desktop
          maxWidth: fullScreen ? "100%" : "45vw",
        },
      }}
    >
      <DialogTitle id="responsive-dialog-title">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {room?.roomType}
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContent>
          <ImageGalleryComponent images={images} />
        </DialogContent>
        <DialogContentText>
          <strong>Detalle de la habitación</strong>
        </DialogContentText>
        <DialogContentText sx={{  mb: 1 }}>{room?.detalleTipoHab}</DialogContentText>
        <DialogContentText>{room?.description1}</DialogContentText>
        <DialogContentText>{room?.description2}</DialogContentText>
        <DialogContentText>{room?.description3}</DialogContentText>
        <Grid container spacing={3}>
          {room?.services.map((service, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  margin: "12px",
                }}
              >
                {service.icon ? (
                  <>
                    <span style={{ fontSize: "24px", marginRight: "8px" }}>
                      {service.icon}
                    </span>
                    <span style={{ marginTop: "8px", textAlign: "center" }}>
                      {service.description}
                    </span>
                  </>
                ) : null}
              </div>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
